<template>
  <div class="container container--small container--tight">
    <div class="box box--default text-center">
      <h3 class="mrgt0 mrgb--">
        {{ gettext('Estimation de votre consommation') }}
      </h3>
      <div class="text-brand text-bold text-huge">
        <template v-if="usageId === 'mobility'">
          {{ formatNumber(mobilityTotal) }} kg
        </template>
        <template v-else>
          {{ formatNumber(simulation.consumption) }} kWh
        </template>
      </div>
      <div v-if="shouldIncludePower && simulation.power" class="mrgt--">
        {{
          interpolate(
            gettext('Sur la base d’une puissance d’installation de %s KW.'),
            [formatNumber(simulation.power)]
          )
        }}
      </div>
      <template v-if="usageId === 'mobility'">
        <div class="mrgt--">
          {{
            gettext(
              'Le kilo de gaz naturel-biogaz coûte 1,44 CHF/kg, soit 0,98 CHF/l. équivalent essence sur le réseau Holdinova. Le gaz naturel carburant contient d’office 20% de biogaz, sans surcoût pour le client.'
            )
          }}
        </div>
        <div class="mrgt- text-muted text-small">
          {{
            gettext(
              'Afin de soutenir la production de biogaz local et son utilisation dans la mobilité, Energiapro a fait le choix d’inclure d’office une part de 20% de cette énergie renouvelable dans le gaz naturel carburant.'
            )
          }}
        </div>
      </template>

      <div class="box__footer">
        <div class="text-muted text-small">
          {{
            gettext(
              'Le résultat de cette simulation est une estimation et n’engage pas la société.'
            )
          }}
        </div>
        <button
          type="button"
          class="btn btn--primary mrgt"
          @click="$emit('next')"
        >
          {{ gettext('Choix du produit') }}
          <Icon id="chevron-right" class="icon--75 mrgl--" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatNumber } from '@/helpers/utils';
import { useSimulation } from '@/composables/useSimulation';

const { usageId, mobilityTotal, simulation, shouldIncludePower } =
  useSimulation();
</script>
